import React from 'react';
import { FeedbackMessage } from '@creditas/feedback-message';

import { CodeTypes } from '../types/message.types';
import { MessageState } from '../redux/message.redux.types';
import { EnumCodeTypes } from '../../../services/http/http.codes';

import MessageStyled from './message.style';

type MessageCmpProps = MessageState;

const MessageComponent: React.FC<MessageCmpProps> = (
  props: MessageCmpProps,
) => {
  const { showMessage, type, message } = props;
  const variant: CodeTypes = {
    [EnumCodeTypes.SUCCESS]: 'success',
    [EnumCodeTypes.ERROR]: 'danger',
    [EnumCodeTypes.INFO]: 'info',
  };
  return (
    <MessageStyled>
      <FeedbackMessage
        className={showMessage ? 'message message-active' : 'message'}
        variant={type !== '' ? variant[type] : 'info'}
      >
        {message}
      </FeedbackMessage>
    </MessageStyled>
  );
};
export default MessageComponent;
